import { Link, useLocation } from 'react-router-dom';
import { useState } from 'react';
import { Menu, X, GraduationCap } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Courses', path: '/courses' },
    { name: 'Teachers', path: '/teachers' },
    { name: 'Contact', path: '/contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="bg-white border-b border-slate-200 sticky top-0 z-50 shadow-sm">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex justify-between items-center">
          <Link to="/" className="flex items-center space-x-2" data-testid="logo-link">
            <GraduationCap className="h-8 w-8 text-brand-blue" />
            <span className="text-2xl font-bold text-brand-dark font-display">Tutor Flex</span>
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`nav-${link.name.toLowerCase()}`}
                className={`text-base font-medium transition-colors ${
                  isActive(link.path)
                    ? 'text-brand-blue'
                    : 'text-slate-600 hover:text-brand-blue'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link to="/student/login">
              <Button data-testid="nav-student-login-btn" variant="outline" className="border-brand-blue text-brand-blue hover:bg-blue-50 rounded-full px-6 py-2 mr-2">
                Student Login
              </Button>
            </Link>
            <Link to="/enroll">
              <Button data-testid="nav-enroll-btn" className="bg-brand-dark hover:bg-slate-800 text-white rounded-full px-6 py-2">
                Enroll Now
              </Button>
            </Link>
          </div>

          <button
            data-testid="mobile-menu-toggle"
            className="md:hidden"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {isOpen && (
          <div className="md:hidden mt-4 pb-4" data-testid="mobile-menu">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsOpen(false)}
                className={`block py-2 text-base font-medium transition-colors ${
                  isActive(link.path)
                    ? 'text-brand-blue'
                    : 'text-slate-600 hover:text-brand-blue'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link to="/student/login" onClick={() => setIsOpen(false)}>
              <Button className="w-full mt-2 border-brand-blue text-brand-blue bg-white hover:bg-blue-50 rounded-full" variant="outline">
                Student Login
              </Button>
            </Link>
            <Link to="/enroll" onClick={() => setIsOpen(false)}>
              <Button className="w-full mt-2 bg-brand-dark hover:bg-slate-800 text-white rounded-full">
                Enroll Now
              </Button>
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
}
